import { createSelector } from "reselect";
import { isInternalUser } from "./constants";
import { IUserState } from "../User/reducer";

const user = (state: any) => state.user;

export const userPermitted = createSelector(user, (user) => {
  return user.name.length > 0 && user.email.length > 0;
});

export const user_id = createSelector(user, (user) => {
  return user.uid;
});

export const currentUserIsInternal = createSelector(user, (user: IUserState) =>
  isInternalUser(user.email)
);

export const getUserContext = createSelector(user, (user: any) => {
  const { uid, email, permissions } = user;

  if (permissions.access_marketplace_dashboard) {
    const merchantPermissions =
      permissions.access_marketplace_dashboard.Merchant;
    const userAvailableMerchants = Array.isArray(merchantPermissions)
      ? merchantPermissions.join(", ")
      : "all";
    const userType = isInternalUser(email) ? "internal" : "external";
    return { userType, userAvailableMerchants, userID: uid };
  }

  return null;
});



// WEBPACK FOOTER //
// ./client/modules/User/selectors.ts